import { css } from '@emotion/react';

export const formBuilderStyles = css`
	html {
		font-size: 16px !important;
	}

	* {
		box-sizing: border-box;
	}

	body {
		margin: 0;
		padding: 0;
		font-style: 'Source Sans Pro', sans-serif;
		overflow: auto !important;
	}

	/* .MuiOutlinedInput-notchedOutline {
    border-color: #c4c4c4 !important;
} */

	/* .MuiAccordion-root.Mui-expanded {
    margin : 0 !important
}

.MuiAccordion-root.Mui-expanded:before {
    opacity: 1 !important;
} */

	.MuiCircularProgress-root {
		display: flex !important;
		margin-left: auto !important;
		margin-right: auto !important;
		margin-top: 50px !important;
		margin-bottom: 50px !important;
	}

	.screenreader {
		position: absolute;
		left: -9999px;
	}
`;
